export default __webpack_public_path__ + "static/media/3.773e41cf.svg";